import { useState } from "react";

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Tooltip from '@mui/material/Tooltip';


/* import formatearDatosAdicionales from "../../helpers/datos/formatearDatosAdicionales"; */
import { generarPDFPorFolio } from "../../helpers/pdf/generarPDFPorFolio";
import nombreUsuario from "../../helpers/usuario/nombre";
import formatearFecha from "../../helpers/datos/formatearFecha";

export default function HistorialLista({ data, catalogos }) {

    const { historialArray } = data;
    const [index, setIndex] = useState(0);

    const rows = [];
    function createData(folio, observaciones, conceptos, lista, fecha, usuario) {
        return { folio, observaciones, conceptos, lista, fecha, usuario };
    }
    if (historialArray) {
        data?.historialArray[index]?.forEach(item => {
            if (!item.conceptos[0]) return;
            rows.push(
                createData(
                    item.idPolizaPago,
                    /* formatearDatosAdicionales(item.datosAdicionales.toUpperCase()) === ""
                        ? "-"
                        : formatearDatosAdicionales(item.datosAdicionales.toUpperCase()), */
                        item.datosAdicionales.toUpperCase(),
                    item.conceptos[0] + (item?.conceptos.length - 1 !== 0 ? `...(${item?.conceptos.length - 1} más)` : ""),
                    item.conceptos,
                    item.fechaPago,
                    item.idUsuarioElabora
                )
            );
        });
    }

    function cambiarPaginacionAdelante() {
        if (historialArray !== undefined)
            setIndex((index + 1) % (historialArray?.length));
    }

    function cambiarPaginacionAtras() {
        if (historialArray !== undefined) {
            if (index === 0) setIndex(historialArray.length - 1);
            else setIndex((index - 1) % (historialArray.length));
        }
    }


    function obtenerPolizaPorIdPoliza(idPoliza, idUsuario) {
        const endpoint = `/api/poliza/ObtenerOrdenPagoPorIdPoliza/${idPoliza}`;
        fetch(endpoint)
            .then(responsePoliza => responsePoliza.ok && responsePoliza.json())
            .then(dataPoliza => {
                const polizas = dataPoliza.data;
                generarPDFPorFolio(polizas, data, nombreUsuario(idUsuario, catalogos?.usuarios));
            })
            .catch(error => console.error(error));
    }

    return (
        <>
            <button className="btn-paginar"><span className="material-icons" onClick={cambiarPaginacionAtras}>navigate_before</span></button>
            {`${historialArray !== undefined && historialArray[index] !== undefined ? index + 1 : 0} de ${historialArray !== undefined ? historialArray.length : 0}`}
            <button className="btn-paginar"><span className="material-icons" onClick={cambiarPaginacionAdelante}>navigate_next</span></button>

            <TableContainer component={Paper}>
                <Table sx={{ minWidth: 650 }} aria-label="simple table">
                    <TableHead style={{ backgroundColor: "#D4C19C" }} sx={{ color: "white" }}>
                        <TableRow>
                            <TableCell align="left"><strong style={{ color: "White" }}>FOLIO</strong></TableCell>
                            <TableCell align="left"><strong style={{ color: "White" }}>OBSERVACIONES</strong></TableCell>
                            <TableCell align="left"><strong style={{ color: "White" }}>CONCEPTOS</strong></TableCell>
                            <TableCell align="right"><strong style={{ color: "White" }}>FECHA DE PAGO</strong></TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {rows.map((row) => (
                            <TableRow
                                key={row.folio}
                                className="tabla"
                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                onClick={() => obtenerPolizaPorIdPoliza(row.folio, row.usuario)}
                            >
                                <TableCell align="left" className="tablaTexto">{row.folio}</TableCell>
                                <TableCell component="th" scope="row" className="tablaTexto">{row.observaciones}</TableCell>
                                <TableCell align="left" className="tablaTexto">
                                    <Tooltip title={`- ${row.lista.join(" - ")}`} arrow>
                                        {row.conceptos}
                                    </Tooltip>
                                </TableCell>
                                <TableCell align="right" className="tablaTexto">{formatearFecha(row.fecha)}</TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </>
    );
}

